export const TabButton = ({
  label,
  isActive,
  onClick,
  position,
}: {
  label: string;
  isActive: boolean;
  onClick: () => void;
  position: 'left' | 'middle' | 'right';
}) => {
  const positionClasses = {
    left: 'rounded-l-md',
    middle: '-ml-px',
    right: 'rounded-r-md -ml-px',
  };

  return (
    <button
      onClick={onClick}
      className={`relative border px-2 py-1 text-xs font-semibold transition-all duration-200 sm:px-4 sm:py-2 sm:text-sm ${
        positionClasses[position]
      } ${
        isActive
          ? 'z-10 border-transparent bg-gradient-to-br from-pink-500 to-purple-600 text-white'
          : 'border-gray-300 bg-transparent text-gray-500 hover:bg-gray-100 dark:border-neutral-700 dark:text-gray-400 dark:hover:bg-neutral-800'
      }`}
    >
      {label}
    </button>
  );
};
